<a target="_NEW" [href]="'./assets/125812154.pdf' + '?' + productId">
  <i class="fa fa-download ml-1"></i>
</a>
